import { Component, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { AiChatOption, AiChatSelectValue } from '@app/shared/models/agent-chat.models';
import { AiChatCustomValueComponent } from '../ai-chat-custom-value/ai-chat-custom-value.component';
import { AiChatGateActionsBase } from '../ai-chat-gate-actions-base';

@Component({
  selector: 'fastr-ui-ai-chat-single-select',
  templateUrl: './ai-chat-single-select.component.html',
  styleUrls: ['./ai-chat-single-select.component.scss'],
})
export class AiChatSingleSelectComponent extends AiChatGateActionsBase implements OnDestroy {
  @Input() question = '';
  /** False once the question has already been streamed into the reply bubble. */
  @Input() animateQuestion = true;
  @Input() options: { label: string; description: string }[] = [];
  @Input() allowCustomValue = true;
  @Input() customValuePlaceholder = 'Type your own';
  @Input() showVoiceIcon = true;
  @Input() requireSelection = true;

  @Output() submitted = new EventEmitter<AiChatSelectValue>();

  selectedIds = new Set<string | number>();

  private _customValue = '';
  get customValue(): string {
    return this._customValue;
  }
  set customValue(val: string) {
    this._customValue = val;
    if (val && val.length > 0) {
      this.selectedIds.clear();
    }
  }

  @ViewChild(AiChatCustomValueComponent) private customValueInput?: AiChatCustomValueComponent;

  ngOnDestroy(): void {
    this.stopVoiceDictation();
  }
  toggleOption(option: { label: string; description: string; disabled?: boolean }): void {
    if (option.disabled) {
      return;
    }
    if (this.selectedIds.has(option.label)) {
      this.selectedIds.delete(option.label);
    } else {
      this.selectedIds.clear();
      this.customValue = '';
      this.selectedIds.add(option.label);
    }
  }
  submit(): void {
    if (!this.canSubmit()) {
      return;
    }

    this.stopVoiceDictation();
    /* eslint-disable @typescript-eslint/no-explicit-any */
    this.submitted.emit(this.getValue() as any);
  }

  isSelected(option: AiChatOption | any): boolean {
    return this.selectedIds.has(option.label);
  }

  canSubmit(): boolean {
    return !this.requireSelection || this.hasAnyValue();
  }

  protected override stopVoiceDictation(): void {
    this.customValueInput?.stop();
  }

  protected override hasAnyValue(): boolean {
    return this.selectedIds.size > 0 || this.customValue.trim().length > 0;
  }

  private getValue() {
    return {
      selectedOptions: this.options.filter((option) => this.selectedIds.has(option.label)),
      customValue: this.customValue.trim() || undefined,
    };
  }
}
